import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'rsuite';
import { AlertMsgEmailSendFailure } from '@/alert-string-constants';
import { RSUITE_ALERT_DURATION } from '@/constants';
import * as dataActions from '@/data/data-actions';
import { strOracleApiSender } from '@/utils/stroracle-api-sender';
import { LicenseEmailViewer } from './license-email-viewer';
import * as modal from './license-modal-styles';
import { toaster } from '@/utils/toaster';
function SuccessModal(props) {
  const { showLicense, setShowLicense, setShowSuccessModal } = props;

  const handleModalClose = () => {
    setShowLicense(false);
    setShowSuccessModal(false);
  };

  return (
    <Modal size="sm" open={showLicense} onClose={handleModalClose}>
      <Modal.Header closeButton={false}>
        <Modal.Title>Success</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        An email with license details has been sent to the applicant.
      </Modal.Body>

      <Modal.Footer>
        <modal.Send
          width="80px"
          appearance="primary"
          onClick={handleModalClose}
        >
          OK
        </modal.Send>
      </Modal.Footer>
    </Modal>
  );
}

function LicenseDisplayModal(props) {
  const dispatch = useDispatch();

  const { index, license, showLicense, setShowLicense, setShowSuccessModal } =
    props;

  const handleLicenseSend = async () => {
    try {
      const { data: updatedLicense } = await strOracleApiSender.post(
        `/send_to_license_holder/${license.licenseId}`
      );
      dispatch(
        dataActions.serverSentLicenseToHolder({
          index,
          license: updatedLicense,
        })
      );
      setShowSuccessModal(true);
    } catch (err) {
      toaster.error(AlertMsgEmailSendFailure, RSUITE_ALERT_DURATION.NONE);
      setShowLicense(false);
    }
  };

  return (
    <modal.PaddedModal
      size="lg"
      overflow={false}
      open={showLicense}
      onClose={() => setShowLicense(false)}
    >
      <Modal.Header>
        <modal.Title>{license.propertyInfo?.propertyAddress}</modal.Title>
        <modal.Tip>Email Preview</modal.Tip>
      </Modal.Header>

      <Modal.Body>
        <LicenseEmailViewer licenseDeckardid={license.licenseDeckardid} />
      </Modal.Body>

      <Modal.Footer>
        <modal.Close appearance="ghost" onClick={() => setShowLicense(false)}>
          Cancel
        </modal.Close>

        <modal.Send appearance="primary" onClick={handleLicenseSend}>
          Send
        </modal.Send>
      </Modal.Footer>
    </modal.PaddedModal>
  );
}

export function LicenseModal(props) {
  const { index, license, showLicense, setShowLicense } = props;

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  if (showSuccessModal) {
    return (
      <SuccessModal
        showLicense={showLicense}
        setShowLicense={setShowLicense}
        setShowSuccessModal={setShowSuccessModal}
      />
    );
  }

  return (
    <LicenseDisplayModal
      index={index}
      license={license}
      showLicense={showLicense}
      setShowLicense={setShowLicense}
      setShowSuccessModal={setShowSuccessModal}
    />
  );
}
